/* eslint-disable max-len */
import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    globalVariables:[],
    vitalInfo:[],
    filterState:[],
    viewToHistory:'',
    viewToUser:'',
    organization_id:'',
    location_key:'',
    viewOrgUser:'',
    restrict:false,
    viewPatient:'',
    messageSent:false,
    editingUserId:'',
    sidebarPrvState:false,
    viewOrg_id:'',
}

// export const GetCommonData = createAsyncThunk('commondata', async (id) =>  handlefetch(id))

            
const SystemConfigSlice = createSlice({

    name: 'SystemConfig',
    initialState,
    reducers: {
        handleSystemConfig:(state,action)=>{
            state.globalVariables=action.payload.global_variables
            state.vitalInfo=action.payload.vital_information
        },
      
        resetState:(state)=>{
            state.globalVariables=[]
            state.vitalInfo=[]
            state.restrict=false,
            state.messageSent=false,
            state.editingUserId=''
           
        },
        handleAddFilterValues:(state,action)=>{
            state.filterState=action.payload
        },
        resetFilterState:(state)=>{
            state.filterState=[]
        },
        /* The `handleIsViewScreen` reducer in the SystemConfigSlice is updating the state with the
        value passed in the action payload at index 0. It sets the `viewToHistory` state property to
        the value received in the payload. */
        handleIsViewScreen:(state,action)=>{
            state.viewToHistory=action.payload[0]
        },
        handleIsUserScreen:(state,action)=>{
            state.viewToUser=action.payload[0]
            state.organization_id=action.payload[1]
        },
        handleViewUserScreen:(state,action)=>{
            state.viewOrgUser=action.payload[0]
        },
        handleLocationKey:(state,action)=>{
            state.location_key=action.payload
        },
        handleRestrictKey:(state,action)=>{
            state.restrict=action.payload
        },
        handleIsViewpatient:(state,action)=>{
            state.viewPatient=action.payload[0]
        },
    
        handleEditMessageSent:(state,action)=>{
            state.messageSent=action.payload
        },
        handleTargetUserEditId:(state,action)=>{
            state.editingUserId=action.payload
        },
        handleSidebarPrvState:(state,action)=>{
            state.sidebarPrvState=action.payload
        },
        handleViewOrgId:(state, action)=>{
            state.viewOrg_id=action.payload
        }

    },
   
})
export const {handleTargetUserEditId,handleEditMessageSent,handleRestrictKey,handleLocationKey,handleIsUserScreen,handleIsViewScreen,handleSystemConfig,resetState,handleAddFilterValues,resetFilterState,handleViewUserScreen,handleIsViewpatient,handleSidebarPrvState,handleViewOrgId } = SystemConfigSlice.actions;
export default SystemConfigSlice.reducer